import { NgModule } from "@angular/core";
import { NgSelectModule } from "@ng-select/ng-select";
import { TranslateModule } from "@ngx-translate/core";
import { IonicPageModule } from "ionic-angular";
import { IonicModule } from "ionic-angular/module";
import { CommonComponentsModule } from "../../components/common/common-components.module";
import { ComponentsModule } from "../../components/components.module";
import { ConfigurableCardsModule } from "../../components/configurable/cards/configurable-cards.module";
import { ToolsModule } from "../../components/tools/tools.module";
import { NavigationModule } from "../../navigation/navigation.module";
import { CompanyPageModule } from "../company/company.module";
import { UserSettings } from "./user-settings";
import { UserSettingsNavigation } from "./user-settings-navigation/user-settings-navigation";

@NgModule({
  declarations: [UserSettings, UserSettingsNavigation],
  imports: [
    IonicPageModule.forChild(UserSettings),
    TranslateModule.forChild(),
    ConfigurableCardsModule,
    NavigationModule,
    ToolsModule,
    CommonComponentsModule,
    ComponentsModule,
    IonicModule,
    NgSelectModule,
    CompanyPageModule,
  ],
  exports: [UserSettingsNavigation, UserSettings],
  entryComponents: [],
})
export class UserSettingsModule {}



// WEBPACK FOOTER //
// ./src/pages/user-settings/user-settings.module.ts